import {Injectable} from '@angular/core';

@Injectable()
export class ThresholdUtil {
  public static readonly START_TIME = 6;
  public static readonly END_TIME = 30;

  public static readonly START_MINUTES = 0;
  public static readonly END_MINUTES = 60;
  public static readonly INCREMENT = 5;

  constructor() {}

  _buildStartTime(hourBlock) {
    return {
      display: this.convertBlockToStartTime(hourBlock),
      value: hourBlock
    }
  }

  _buildEndTime(hourBlock) {
    return {
      display: this.convertBlockToEndTimeDisplay(hourBlock),
      value: hourBlock + 1
    }
  }

  _pad(value, size) {
    let s = String(value);
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
    return s;
  }

  convertThresholdToUiModel(threshold) {
    return {
      start: this.convertStartTimeToBlock(threshold.start),
      end: this.convertEndTimeToBlock(threshold.end),
      threshold: threshold.threshold,
      groupThreshold: threshold.groupThreshold,
      groupThresholdCloseout: threshold.groupThresholdCloseout,
    }
  }

  convertUiModelToThreshold(uiThreshold) {
    return {
      start: this.convertBlockToStartTime(uiThreshold.start),
      end: this.convertBlockToEndTimeValue(uiThreshold.end),
      threshold: uiThreshold.threshold,
      groupThreshold: uiThreshold.groupThreshold,
      groupThresholdCloseout: uiThreshold.groupThresholdCloseout,
    }
  }

  convertStartTimeToBlock(start: string) {
    if (!start)
      return ThresholdUtil.START_TIME;

    let a: string[] = start.split(":");
    let v = parseInt(a[0]);
    if (v >= ThresholdUtil.START_TIME && v <= ThresholdUtil.END_TIME)
      return v;

    return ThresholdUtil.START_TIME;
  }

  convertEndTimeToBlock(end: string) {
    if (!end)
      return ThresholdUtil.END_TIME;

    let a: string[] = end.split(":");

    if (a.length < 2)
      return ThresholdUtil.END_TIME;

    let hours = parseInt(a[0]);
    let minutes = a[1];

    if (hours >= ThresholdUtil.START_TIME && hours <= ThresholdUtil.END_TIME) {
      return minutes == '59' ? (hours + 1) : hours;
    }

    return ThresholdUtil.END_TIME;
  }

  convertBlockToStartTime(block) {
    return this._pad(block, 2) + ":00";
  }

  convertBlockToEndTimeValue(block) {
    return this._pad(block, 2) + ":00";
  }

  convertBlockToEndTimeDisplay(block) {
    return this._pad(block, 2) + ":59";
  }

  parseHour(value: string) {
    if (!value)
      return null;

    let a: string[] = value.split(":");
    if (a.length < 2)
      return null;

    let v = parseInt(a[0]);
    return this._pad(v, 2);
  }

  parseMin(value: string) {
    if (!value)
      return null;

    let a: string[] = value.split(":");
    if (a.length < 2)
      return null;

    let v = parseInt(a[1]);
    return this._pad(v, 2);
  }

  constructTime(hour: string, min: string) {
    if (!hour || !min)
      return null;
    return hour + ":" + min;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/util/threshold.ts